import React , { useEffect }from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";

const JobDetailPage1 = () => {


     useEffect(() => {
                window.scrollTo(0, 0); // Scroll to top when component loads
              },[]);

              const navigate = useNavigate();

  return (
    <Box>
      {/* Header Section */}
      <Box>
 
  <Box
    sx={{
      background: "radial-gradient(circle, #1F6788,#161623)",
      color: "white",
      py: 15, // Increased vertical padding to make it taller
      px: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    }}
  >
    <Typography variant="h3" fontWeight="bold" mb={3}>
      UI Developer
    </Typography>

    <Button
      variant="contained"
      sx={{
        backgroundColor: "white",
        color: "#1F6788",
        fontWeight: 600,
        px: 4,
        py: 1.5,
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      }}
      onClick={() => navigate("/contact")}
    >
      Apply now
    </Button>
  </Box>
</Box>


     {/* Main Content */}
     <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    px: { xs: 3, sm: 4, md: 2 }, // More horizontal padding on mobile
    py:10,
    width: "100%",
    backgroundColor: "#B0E0E6",
  }}
>

<Box
  sx={{
    px: { xs: 2.5, sm: 3, md: 6 }, // Horizontal padding only
    py: { xs: 0, md: 6 },
    maxWidth: "1200px",
    width: "100%",
    mx: "auto", // ensures it's centered
  }}
>

<Box
  sx={{
    ml: { xs: "0px", md: 0 },
    mr: { xs: "22px", md: 0 },
  }}
>
    <Grid container spacing={4}>
      {/* Left Side - Job details */}
      <Grid item xs={12} md={4}>
        <Typography variant="body1" fontWeight="bold">Job details</Typography>
        <Typography mt={2}><strong>Work Location</strong><br />Remote</Typography>
        <Typography mt={2}><strong>Country</strong><br />India</Typography>
        <Typography mt={2}><strong>Company</strong><br />Tech Informatic Solutions</Typography>
      </Grid>

      {/* Right Side - Job Description */}
      <Grid item xs={12} md={8}>
        <Typography  variant="h6" fontWeight="bold">Job Description</Typography>

        <Box mt={2}>
          <Typography variant="body2" lineHeight={1.5} mb={2}><strong>Role –</strong> UI Developer</Typography>
          <Typography variant="body2" lineHeight={1.5} mb={2}><strong>Location –</strong> Remote, India</Typography>
        </Box>

        <Box mt={3}>
          <Typography  variant="h6" fontWeight="bold" mb={1}>Job Summary</Typography>
          <Typography variant="body2" lineHeight={1.7} mb={2}>
          Job Summary: We are seeking a talented UI Developer to join our dynamic team. The ideal candidate will have experience in creating intuitive and engaging user interfaces for web applications.
          </Typography>
          <Typography variant="body2" lineHeight={1.7} mb={2}>
          You will be responsible for translating design mockups into functional, responsive interfaces and working closely with UX designers and backend developers.
          </Typography>

          {/* Requirements */}
          <Typography variant="h6" fontWeight="bold" mb={2}>Requirements</Typography>
          {[
            "Bachelor’s degree in marketing, business administration, or a related field is preferred",
            "0 to 3 years experience",
            "Proven experience as a UI Developer or similar role.",
            "Strong portfolio demonstrating UI design and development skills.",
            "Proficiency in HTML, CSS, and JavaScript.",
            "Experience with frontend frameworks such as React, Angular, or Vue.js. Knowledge of responsive design principles and tools.",
            
          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}

          {/* Responsibilities */}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>Responsibilities</Typography>
          {[
            "Develop and maintain user interfaces for web applications.",
            "Collaborate with UX designers to implement design concepts and ensure alignment with user needs.",
            "Write clean, maintainable, and efficient code.",
            " Test and debug UI components to ensure a seamless user experience across different devices and browsers.",
            " Stay up-to-date with emerging trends and technologies in UI development."

         


          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}

          {/* Must Have */}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>Must Have</Typography>
          {[
           "Solid experience with UI development tools and frontend frameworks.",
  "Proficiency in HTML, CSS, and JavaScript.",
  "Strong problem-solving skills and attention to detail.",
  "Soft Skills: some text",
  "Creativity: Ability to come up with innovative design solutions.",
  "Attention to Detail: Ensuring accuracy and quality in UI elements.",
  "Problem-Solving: Ability to troubleshoot and resolve UI-related issues.",
  "Communication Skills: Effectively collaborate with team members and stakeholders.",
  "Time Management: Ability to manage multiple tasks and meet deadlines."

          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}

          

          {/* Hard Skills */}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>Hard Skills</Typography>
          {[
            "UI Development Tools: Experience with tools like Adobe XD, Figma, or Sketch.",
            "HTML/CSS: Proficiency in creating and styling web pages.",
             // eslint-disable-next-line no-script-url
            "JavaScript: Ability to create dynamic and interactive web elements.",


            "Responsive Design: Knowledge of designing for various screen sizes and devices.",
            "Frontend Frameworks: Experience with React, Angular, or Vue.js."
          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>



            
          ))}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}></Typography>
          {[
            "All aspects of employment at Tech Informatic Solutions are based on merit, competence and performance. We are committed to embracing diversity and creating an inclusive environment for all employees. TIS is proud to be an equal opportunity employer",
            
          ].map((text, index) => (
            <Typography key={index} variant="body2"  fontWeight="bold" lineHeight={1.7} mb={1}>{text}</Typography>



            
          ))}



    {/* Bottom Buttons */}
    <Box mt={5} display="flex" gap={2} >
      <Button variant="contained" sx={{ backgroundColor: '#1F6788' }}  onClick={() => navigate("/contact")} >Apply now</Button>
      
    </Box>



        </Box>
      </Grid>
    </Grid>
    </Box>
  </Box>
</Box>

    </Box>
  );
};

export default JobDetailPage1;
